import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Returns day & month for event badge using event timezone
 * @param {Object} event
 */
export const formatEventDateBadge = (event) => {
  if (!event?.start_date) {
    return { day: "-", month: "-" };
  }

  // Date-only model: read the stored calendar date in UTC, no timezone conversion.
  const date = dayjs.utc(event.start_date);

  if (!date.isValid()) {
    return { day: "-", month: "-" };
  }

  return {
    day: date.format("DD"),
    month: date.format("MMM"),
  };
};
